export { default } from "./ClientsList";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/side-menu/ClientsList/index.js